import {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from '../../../../components/bootstrap/Modal';
import {useMst} from '../../../../models';
// import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc';
import Icon from '../../../../components/icon/Icon';
import Button from '../../../../components/bootstrap/Button';
import DepartmentService from '../../../../services/DepartmentService';
import {toggleExpandedForAll, getFlatDataFromTree} from '@nosferatu500/react-sortable-tree';
import DndSortableTree from '../../../../components/extras/DndSortableTree';
import FileExplorerTheme from '@nosferatu500/theme-file-explorer';
import Input from '../../../../components/bootstrap/forms/Input';
import Avatar from 'react-avatar';
import showNotification from '../../../../components/extras/showNotification';
import Checks from '../../../../components/bootstrap/forms/Checks';
import Badge from '../../../../components/bootstrap/Badge';
import {ReactSortable} from 'react-sortablejs';
import {cloneDeep} from 'lodash';
import BtnTrashbin from "../../../../assets/img/btns/btn_trashbin.svg";
import ThemeContext from "../../../../contexts/themeContext";
import CompanyService from "../../../../services/CompanyService";
import {
	buildTreeUserMap, getLineUserDept, getLineUserName, getLineUserRank, getTreeUserDeptLangs,
	getTreeDeptName, getTreeUserName, getTreeUserPosition, getTreeUserRank, matchesTreeSearch,
} from 'helpers/orgTreeI18n';

const sortableOptions = {
	animation: 150,
	fallbackOnBody: true,
	swapThreshold: 0.65,
	ghostClass: 'ghost',
	group: 'shared',
};

const registerKindArray = [
	{
		label: 'approve',
		color: 'light',
		value: 'APPROVAL',
		sort: 'SEQ',
	},
	{
		label: 'ccusers',
		color: 'light',
		value: 'CCUSERS',
		// sort: 'PAR',
	},
];

const ApprovalModalMini = (props) => {
	const { t } = useTranslation(); //번역관련
	const { company, user } = useMst();
	const [item, setItem] = useState({});
	const [treeUser, setTreeUser] = useState([]);
	const [selectedTreeUser, setSelectedTreeUser] = useState([]); // disable용 사람체크
	const [selectedTreeUserQueue, setSelectedTreeUserQueue] = useState([]); // 사람체크용 휘발성 큐
	const [timer, setTimer] = useState(0); // 디바운싱 타이머
	const searchRef = useRef(null);
	const [searchedItem, setSearchedItem] = useState([]);
	const [commCodeSelfAppr, setCommCodeSelfAppr] = useState(null);
	const [cc, setCc] = useState([]);
	const [blocks, setBlocks] = useState([]);
	const tr = useCallback((name) => t(`approval.${name}`), [t]);
	const [isSearchFocus, setIsSearchFocus] = useState(false);
	// lineField : 결재자가 담긴 formik 필드명 (기본 approvailLine, 연차계획 회사지정은 approvals)
	const { restRequest, lineField = 'approvailLine' } = props;
	const { [lineField]: approvailLine, ccUsers } = restRequest.values;
	const { mobileDesign } = useContext(ThemeContext);
	const isCalledRefMini = useRef(false);
	const virtuosoRef = useRef(null);
  const didFocusRef = useRef(false);
	// BlockWrapper가 의존성 없는 useCallback이라 조직도 대응표는 ref로 넘긴다
	const treeUserMapRef = useRef(new Map());

	const getTreeUser = async () => {
		DepartmentService.getDepartmentTreeUser(
			company.get.id,
			'SUCCESS',
			null,
			true
		).then(res => {
			if (res?.data?.data) {
				const expandedTreeData = toggleExpandedForAll({
					treeData: res.data.data,
					expanded: true,
				});
				treeUserMapRef.current = buildTreeUserMap(expandedTreeData);
				setTreeUser(expandedTreeData);
				setSearchedItem(expandedTreeData);
			}
		});
	};

	const focusIndex = useMemo(() => {
      const deptId = user?.me?.userDepartmentId;
      if (!deptId || !searchedItem?.length) return 0;

      const flatData = getFlatDataFromTree({
          treeData: searchedItem,
          getNodeKey: ({ node }) => node.idString,
          ignoreCollapsed: true,
      });

      const index = flatData.findIndex(({ node }) => node.idString === `depart-${deptId}`);
      return index < 0 ? 0 : index;
  }, [searchedItem, user?.me?.userDepartmentId]);

	const getCommCodes = async () => {
		// 자가승인 허용기준
		await CompanyService.getCommCodeNew({
			companyId: company?.get?.id,
			commCodeType: 'SELF_APPROVAL_YN'
		}).then(res => {
			setCommCodeSelfAppr(res?.data?.[0]?.etc1 ?? 'N');
		});
	}

	const matchWord = useCallback((str) => {
		switch (str) {
			case 'APPROVAL':
				return '결재';
			case 'AGREEMENT':
				return '합의';
			case 'CC':
				return '참조';
			case 'PAR':
				return '병렬';
			case 'SEQ':
				return '순차';
			default:
				return 'Unknown';
		}
	}, []);

	const createNewContainer = (blocks, index) => {
		let copyBlocks = [...blocks];
		copyBlocks[index] = { line: [blocks[index]] ,  sort : blocks[index].sort, type :  blocks[index].type, itemType : 'container'};

		const updateTargetIndex = blocks.findIndex((x) => x?.line?.map((y) => y.user.userId).includes(blocks[index].user.userId));
		if(updateTargetIndex !== -1){
			copyBlocks[updateTargetIndex] = { ...copyBlocks[updateTargetIndex], line: blocks[updateTargetIndex].line.filter((x) => x.user.userId !== blocks[index].user.userId) };
		}
		return copyBlocks;
	};

	const Container = useCallback(({ block, blockIndex, setBlocks, approvalItem }) => {
		return (
			<>
				<ReactSortable
					style={{ display: 'flex', flexDirection: block.sort === 'PAR' ? 'row' : 'column' }}
					key={block.id}
					disabled={mobileDesign || (approvalItem.departId && !company.get.isDoc)}
					onChoose={(e)=>{

					}}
					onEnd={(e)=>{

					}}
					onStart={(e)=>{

					}}
					onSpill={(e)=>{

					}}
					onAdd={(e)=>{

					}}
					onChange={(e)=>{
						// 작업

					}}
					list={block.line}
					setList={(currentList) => {
						setBlocks((sourceList) => {
							let tempList = [...sourceList];
							const itemIndex = [...sourceList].findIndex((x) => x.itemType === 'item');
							// 신규
							if (itemIndex > -1) {
								tempList = createNewContainer(cloneDeep(sourceList), itemIndex);
							} else {
								// 이동
								tempList[blockIndex[0]].line = currentList;
							}
							tempList = tempList.filter((x) => x?.line?.length > 0);
							// 최종 넣기전 user 랑 container 랑 type sort 동기화 [Song]
							tempList = tempList?.map( list => {
								let t = {...list};
								t.sort = t.type !== 'APPROVAL' && t.line.length > 1 ? 'PAR' : 'SEQ'
								t.line = t.line?.map( user => {
									return {...user, sort: t.sort, type: t.type }
								});
								return t;
							})
							return tempList;
						});
					}}
					{...sortableOptions}>
					{block.line &&
						block?.line?.map((childBlock, index) => {
							return <BlockWrapper key={`c-bw-${index}`} block={childBlock} blockIndex={[...blockIndex, index]} setBlocks={setBlocks} approvalItem={approvalItem}/>;
						})}
				</ReactSortable>
			</>
		);
	}, [company.get.isDoc]);

	const BlockWrapper = useCallback(({ block, blockIndex, setBlocks, approvalItem }) => {
		if (!block) return null;
		if (block.itemType === 'container') {
			return (
				<div className={`sort_list_box ${block?.line?.length > 1 ? 'bg-l50-light' : 'rounded-0'}`}>
					<Container block={block} setBlocks={setBlocks} blockIndex={blockIndex} approvalItem={approvalItem}/>
				</div>
			);
		} else {
			return (
				<div className='list_item'>
					<div><Badge color={'info'} isLight={true} className={''}>{block.order}</Badge></div>
					<div className='user_box tab'>
						{/* pc에서는 상단에 제외 버튼 위치 */}
						{!mobileDesign && (
							<div className='d-flex flex-row justify-content-end align-items-end align-self-end '>
								<div>
									<Button
										type='button'
										//icon='Close'
										size='sm'
										onClick={(e) => {
											setBlocks((blocks) => {
												let copyBlocks = [...blocks];
												const line = [...copyBlocks[blockIndex[0]].line.filter((item, itemIndex) => itemIndex !== blockIndex[1])];
												if (line.length > 0) {
													copyBlocks[blockIndex[0]] = { ...copyBlocks[blockIndex[0]], line: line };
												} else {
													copyBlocks = copyBlocks.filter((item, itemIndex) => itemIndex !== blockIndex[0]);
												}
												return copyBlocks;
											});
											setSelectedTreeUser((selectedTreeUser) => {
												return selectedTreeUser.filter((user) => user.userId !== block.userId);
											});
										}}>
										<small>{tr('exclude')}</small>
									</Button>
								</div>
							</div>
						)}
						<div className='user_txt'>
							<div className='mx-2'>
								<Avatar
									round
									textSizeRatio={0.5}
									size={30}
									name={block?.user?.name || ''}
									src={block.user?.profile || null}
								/>
							</div>
							<div className='mx-2'>
								<div className='lh-1'>
									{getLineUserName(block, block?.user, treeUserMapRef.current)} <small>{getLineUserRank(t, block, block?.user, treeUserMapRef.current)}</small>
								</div>
								<div className='lh-1'>
									<small>{getLineUserDept(block, block?.user, treeUserMapRef.current)}</small>
								</div>
							</div>
							<div className='small p-1 me-2'>{t(matchWord(block?.type || ''))}</div>

							{/* 모바일에서는 엑스버튼으로 삭제 */}
							{mobileDesign && (
								<Button
									type='button'
									onClick={(e) => {
										setBlocks((blocks) => {
											let copyBlocks = [...blocks];
											const line = [...copyBlocks[blockIndex[0]].line.filter((item, itemIndex) => itemIndex !== blockIndex[1])];
											if (line.length > 0) {
												copyBlocks[blockIndex[0]] = { ...copyBlocks[blockIndex[0]], line: line };
											} else {
												copyBlocks = copyBlocks.filter((item, itemIndex) => itemIndex !== blockIndex[0]);
											}
											return copyBlocks;
										});
										setSelectedTreeUser((selectedTreeUser) => {
											return selectedTreeUser.filter((user) => user.userId !== block.userId);
										});
									}}
								>
									<Icon icon="Cancel" size="lg"/>
								</Button>
							)}
						</div>
					</div>
				</div>
			);
		}
	}, []);

	const registSelectedUser = (selectedUsers, kindItem) => {
		const copiedUsers = [...selectedUsers].map((users) => ({ ...users, itemType: 'item' }));
		const line = [...blocks];
		let ccUsers = [...cc];
		if(kindItem.value === 'APPROVAL') {
			for(const u in copiedUsers) {
				line.push({
					type: kindItem.value,
					sort: kindItem.sort,
					itemType: 'container',
					line: [copiedUsers[u]],
				});
			}
		} else if (kindItem.value === 'CCUSERS') {
			selectedUsers.map(i => {
				ccUsers.push({
					companyId: i.companyId,
					department: i.user.department,
					departmentId: i.user.departmentId,
					head: i.user.head,
					name: i.user.name,
					nameEngFirst: i.user.nameEngFirst,
					nameEngLast: i.user.nameEngLast,
					nameVie: i.user.nameVie,
					nameChn: i.user.nameChn,
					positionId:i.user.positionId,
					rank: i.user.rank,
					rankId: i.user.rankId,
					userId: i.user.userId
				})
			})
		}
		setBlocks(line);
		setCc(ccUsers);

		setSelectedTreeUser([...selectedTreeUser, ...selectedUsers]);
		setSelectedTreeUserQueue([]);
	};

	const debounce = (e) => {
		const time = 1000;
		if (timer) clearTimeout(timer);

		if (e.target.value !== '') {
			const newTimer = setTimeout(() => {
				const searchText = e.target.value;

				const filterTreePreservingStructure = (node, searchText, parent = null) => {
					const {children = [], ...rest} = node;
					const restNameMatch = matchesTreeSearch(t, rest, searchText) ||
												  rest.companyNumber?.toLowerCase().includes(searchText);

					if (node.id !== null) {
						// 부서 노드
						const filteredChildren = children
							.map(child => filterTreePreservingStructure(child, searchText, node))
							.filter(child => child !== null);

						if (restNameMatch || filteredChildren.length > 0) {
							return {...node, children: filteredChildren};
						}
						return null;
					} else {
						// 사람 노드 (id === null)
						if (restNameMatch || (parent && matchesTreeSearch(t, parent, searchText))) {
							return {...node, children}; // 사람 노드는 보통 자식 없겠지만 혹시 몰라 유지
						}
						return null;
					}
				};

				const filteredTree = treeUser
					.map((node) => filterTreePreservingStructure(node, searchText))
					.filter((node) => node !== null);

				setSearchedItem(
					toggleExpandedForAll({
						treeData: filteredTree,
						expanded: true,
					})
				);
			}, time);

			setTimer(newTimer);
		} else {
			setSearchedItem([...treeUser]);
		}
	};

	useEffect(() => {
		let copyBlocks = [...blocks];
		let index = 0;
		for(const i in copyBlocks) {
			if(copyBlocks[i].sort === 'PAR') {
				index += 1;
			}
			for(const j in copyBlocks[i].line) {
				if(copyBlocks[i].sort === 'SEQ') {
					index++;//parseInt(j);
				}
				copyBlocks[i].line[j].order = index;
			}
		}

		if (Object.keys(item).length >= 1) {
			setItem({ ...approvailLine, lines: copyBlocks });
		} else {
			setItem({ ...item, lines: copyBlocks });
		}
	}, [blocks]);

	useEffect(() => {
		// 최초 진입시 한번만 실행되고 그뒤로는 조직도 전체검색 방지
		if (!isCalledRefMini.current) {
			getTreeUser();
			getCommCodes();
			isCalledRefMini.current = true;
		}
	}, [])

	useEffect(() => {
		// 팝업창 열리면 결재자, 참조자 넣기
		if (props.isOpen) {
			// 회사지정 결재라인을 불러와 편집하는 경우 정렬용 itemType 이 없을 수 있어 보정
			setBlocks(
				cloneDeep(approvailLine || []).map((container) => ({
					...container,
					itemType: 'container',
					line: (container?.line || []).map((x) => ({ ...x, itemType: 'item' })),
				}))
			);
			setCc(ccUsers || []);
		}else{
			setSelectedTreeUser([]);
			setSelectedTreeUserQueue([]);
			// 조직도 검색 초기화
			setSearchedItem([...treeUser]);
		}
		return () => {
			// setHaveRandered(false);
			setSelectedTreeUser([]);
			setSelectedTreeUserQueue([]);
			setBlocks([]);
			setCc([]);
		};
	}, [props.isOpen]);

	useEffect(() => {
					if (!props.isOpen) {
									didFocusRef.current = false;
									return;
					}
					if (didFocusRef.current || focusIndex <= 0) return;

					didFocusRef.current = true;
					const raf = requestAnimationFrame(() => {
									virtuosoRef.current?.scrollToIndex({ index: focusIndex, align: 'start' });
					});
					return () => cancelAnimationFrame(raf);
					// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.isOpen, focusIndex]);

	return (
		<>
			<Modal isCentered isStaticBackdrop={true} size={'xl'} setIsOpen={props.setIsOpen} isOpen={props.isOpen} fullScreen={'sm'} modalClassNameProps='approval_modal'>
				<ModalHeader setIsOpen={props.setIsOpen} className={'pb-0'}>
					<ModalTitle className='d-flex align-items-center fs-3 fw-bold'>
						{`${tr('approvalLine')} ${t('workType.designate')}`}
					</ModalTitle>
				</ModalHeader>
				<hr />
				<ModalBody>
					<div className='row px-2'>
						<div className='col-sm-4 text-end border-end h-auto overflow-hidden position-relative'>
							<div className={`org-sch ${mobileDesign ? 'mb-1' : 'mb-4'}`}>
								<Input
									ref={searchRef}
									placeholder={`${t('holidayWorkLog.searchNameDep')}`}
									onChange={debounce}
									onFocus={() => setIsSearchFocus(true)}
									onBlur={() => setIsSearchFocus(false)}
									style={{
										height: 'clamp(42px, 5vh, 52px)',
									}}
								/>
								<Button
									type="button"
									onClick={() => {
										setSearchedItem([...treeUser]);
										searchRef.current.value = '';
									}}
									style={{
										position: 'absolute',
										top: 20,
										right: 12,
										transform: 'translateY(-50%)',
										padding: 15,
										border: '0',
										cursor: 'pointer',
										color: '#8A90A0',
										boxShadow:'none',
										zIndex: 2,
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.color = '#556EE6';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.color = '#8A90A0';
									}}
								>
									<Icon icon="Close" size="xl" />
								</Button>
							</div>
							<DndSortableTree
								style={{
									height: '60vh',
									maxHeight: mobileDesign
										? 'calc(45vh - 50px)'
										: 'calc(100vh - 120px)',
									overflowY: 'auto',
								}}
								virtuosoRef={virtuosoRef}
      					virtuosoProps={{ initialTopMostItemIndex: focusIndex }}
								className='sortable_tree'
								treeData={searchedItem}
								onChange={setSearchedItem}
								maxDepth={10}
								getNodeKey={({ node }) => node.id}
								canDrag={false}
								theme={FileExplorerTheme}
								generateNodeProps={(nodes) => {
									let nodeProps = {
										// onClick: async (e) => {
										// 	e.preventDefault();
										// },
										title: (
											<>
												{nodes.node?.userId ? (
													<div>
														<Checks
															type={'checkbox'}
															label={
																<div>
																	<span className='fw-bold'>{getTreeUserName(nodes.node)}</span>
																	{nodes?.node?.userPosition && nodes?.node?.userPosition !== '-' &&
																		<span className='ms-1 small'>{`| ${getTreeUserPosition(t, nodes.node)}`}</span>
																	}
																	{nodes?.node?.userRank && <span className='ms-2 small fw-light'>({getTreeUserRank(t, nodes.node)})</span>}
																</div>
															}
															checked={
																[...selectedTreeUser, ...selectedTreeUserQueue].map((data) => data.user.userId).includes(nodes.node?.userId) ||
																blocks?.map((lineData) => lineData?.line?.map((x) => x.user.userId).includes(nodes.node?.userId)).includes(true) ||
																cc?.map((data) => data?.userId).includes(nodes.node?.userId)
															}
															disabled={
																commCodeSelfAppr === 'Y'
																	? false
																	: (
																		nodes.node?.userId === user.me.id ||
																	  	selectedTreeUser.map((data) => data.user.userId).includes(nodes.node?.userId) ||
																	  	blocks?.map(lineData =>
																			lineData?.line?.map((x) => x.user.userId).includes(nodes.node?.userId)
																	  	).includes(true) ||
																	  	cc?.map((data) => data?.userId).includes(nodes.node?.userId)
																	)
															}
															onClick={() => {
																const data = {
																	date: null,
																	memo: '',
																	state: 'REQUEST',
																	companyId: nodes.node.companyid,
																	user: {
																		profile: nodes?.node?.profile,
																		userId: nodes?.node?.userId,
																		name: nodes?.node?.name,
																		// 다국어 이름(화면 표시용)
																		nameEngFirst: nodes?.node?.nameEngFirst,
																		nameEngLast: nodes?.node?.nameEngLast,
																		nameVie: nodes?.node?.nameVie,
																		nameChn: nodes?.node?.nameChn,
																		companyId: nodes.node.companyid,
																		rankId: nodes?.node?.userRankData?.id || 0,
																		rank: nodes?.node?.userRank,
																		positionId: nodes?.node?.userPositionData?.id || 0,
																		position: nodes?.node?.userPositionData?.name || 0,
																		departmentId: nodes?.node?.userDepartmentsData?.departmentId || 0,
																		department: nodes?.node?.userDepartment,
																		// 다국어 부서명(화면 표시용)
																		...getTreeUserDeptLangs(nodes?.node?.userId, nodes?.node?.userDepartment, treeUserMapRef.current),
																		head: nodes?.node?.userDepartmentData?.head || false,
																		readDate: '',
																	},
																	otherUser: {},
																	sussDate: '',
																};
																if (selectedTreeUserQueue.map((data) => data.user.userId).includes(nodes.node?.userId)) {
																	setSelectedTreeUserQueue([...selectedTreeUserQueue.filter((data) => data.user.userId !== nodes.node?.userId)]);
																} else {
																	setSelectedTreeUserQueue([...selectedTreeUserQueue, data]);
																}
															}}
														/>
													</div>
												) : (
													<div>{getTreeDeptName(nodes.node)}</div>
												)}
											</>
										),
									};
									return nodeProps;
								}}
							/>
							{/* <Input type='text' size='sm' placeHolder='결재자 검색' /> */}
						</div>
						<div className='col-sm-2 h-auto row justify-content-center align-items-center'>
							<div className='btn_box'>
								{registerKindArray?.map((arrItem, index) => (
									<Button
										key={`b-${index}`}
										type='button'
										rounded={'0'}
										isOutline={true}
										color={arrItem.color}
										onClick={() => {

											if (!selectedTreeUserQueue.length) {
												showNotification(`${tr(arrItem.label)}`, tr('pleaseInputNumberPeople'), 'danger');
											} else {
												registSelectedUser(selectedTreeUserQueue, arrItem);
											}
										}}>
										<span className='me-3'>{tr(arrItem.label)}</span>
										<Icon icon='KeyboardArrowRight' />
									</Button>
								))}
							</div>
						</div>
						<div className='col-sm-6'>
							{/* 모바일이 아닌 경우만 안내 문구 노출 */}
							{!mobileDesign && (
								<div className={'d-flex justify-content-start align-items-start'}>
									<Icon
										icon='ErrorOutline'
										color='dark'
										size='lg'
										className='me-2'
									/>
									<span>{tr('longPressButton')}</span>
								</div>
							)}

							<div className='overflow-scroll approval_sort_box' style={{ height: '55vh'}}>
								<ReactSortable
									list={blocks}
									setList={setBlocks}
									disabled={mobileDesign || (item.departId && !company.get.isDoc)}
									{...sortableOptions}
									onChoose={(e) => {

									}}
									onEnd={(e) => {

									}}
									onStart={(e) => {

									}}
									onSpill={(e) => {

									}}
									onAdd={(e)=>{

									}}
									onChange={(e)=>{
										// 작업

									}}
									>
									{blocks.map((block, blockIndex) => (
										<BlockWrapper key={block.id} block={block} blockIndex={[blockIndex]} setBlocks={setBlocks} approvalItem={item} />
									))}
								</ReactSortable>
							</div>

							{cc?.length > 0 &&
							<>
								<hr/>
								<div className='user-detail-content-wrapper d-flex flex-wrap'>
									<div className='d-flex align-items-center justify-content-center mx-3'>
										<span>{tr('ccusers')}</span>
									</div>
									{cc?.map((v, i) => {
										return (
											<Button
												style={{
													borderRadius: 6,
													borderWidth: 1,
													borderColor: '#D9D9D9',
													margin: 5,
													backgroundColor: '#F8F9FA',
												}}
												key={`ccUsers-${i}`}
												className='py-1 px-2'
												onClick={() => {
													let newCcUsers = [...cc];
													newCcUsers.splice(i, 1);
													setCc(newCcUsers);
													setSelectedTreeUser((selectedTreeUser) => {
														return selectedTreeUser.filter((user) => user.user?.userId !== cc[i].userId);
													});
												}}>
												<Icon icon='Visibility' size='md' style={{ color: 'grey' }} />
												<span className='mx-3'>
													{getLineUserName(v, v, treeUserMapRef.current)} {cc.length - 1 > i}
												</span>
												<Icon icon='Close' size='md' />
											</Button>
										);
									})}
								</div>
							</>
							}
						</div>
					</div>
				</ModalBody>
				<ModalFooter className='w-100 d-flex justify-content-between align-contents-center'>
					<div></div>
					<div>
						<Button
							className={'align-middle me-2'}
							isOutline
							type={'button'}
							color={'light'}
							rounded={1}
							style={{ borderStyle: 'dashed', width: 120 }}
							onClick={async () => {
								setSelectedTreeUser([]);
								setBlocks([]);
								setCc([]);
							}}>
							<img src={BtnTrashbin} alt='' width='20px' style={{marginTop:'-3px'}} className='btn_delete' />
							{tr('resetSelection')}
						</Button>
						<Button
							type='button'
							color={'info'}
							onClick={async () => {
								// 결재자를 지정하지 않은 경우 체크
								if (!item?.lines?.map((line) => line.type)?.includes('APPROVAL')) {
									return showNotification(tr('approvalLine'), tr('pleaseAddApprover'), 'danger');
								}

								// 결재라인 지정
								restRequest.setFieldValue(
									lineField,
									cloneDeep(item.lines).map((lineItem) => {
										return {
											...lineItem,
											line: lineItem?.line?.map((x) => {
												delete x.chosen;
												delete x.selected;
												return { ...x, type: lineItem.type, sort: lineItem.sort };
											}),
										};
									})
								);

								// 참조자 지정
								restRequest.setFieldValue('ccUsers', cc);
								props.setIsOpen(false);
							}}>
							{t('적용')}
						</Button>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};

// 결재라인 회사지정 모드에서 항상 노출되는 결재라인 편집 버튼 (클릭 시 ApprovalModalMini 오픈)
export const ApprovalLineEditButton = ({ approvalLine, onClick, className = 'mt-2' }) => {
	const { t } = useTranslation();
	return (
		<div className={className}>
			<Button
				type={'button'}
				style={{ borderRadius: 8 }}
				isOutline={true}
				color={'info'}
				onClick={onClick}
			>
				<div className='d-flex align-items-center'>
					<Icon icon='Edit' size='lg' color='info' />
					<span className='custom-write-button-margin'>{t('approval.editApprovalLine')}</span>
				</div>
			</Button>
		</div>
	);
};

export default ApprovalModalMini;
